import { useEffect } from 'react';

const JACADA_CUSTOMIZATIONS = [
  {
    type: 'font',
    name: 'Circular Pro',
    url: 'https://cdn-static.itrvl.com/fonts/circularpro-book/CircularPro-Book.ttf',
  },
];

const CustomizationsLoader = ({ enabled, fileLoadList = JACADA_CUSTOMIZATIONS, children }) => {
  useEffect(() => {
    if (!enabled) return;

    Promise.all(
      fileLoadList.map(async file => {
        //a bit of future proofing without too much
        switch (file.type) {
          case 'font':
            const font = new FontFace(file.name, `url(${file.url})`);
            await font.load();
            document.fonts.add(font);
            break;
          default:
          //do nothing
        }
      }),
    );
  }, [fileLoadList, enabled]);
  return children;
};

export default CustomizationsLoader;
